import React from 'react';
import { Hero } from '../../components/Landing/Hero';
import { Problems } from '../../components/Landing/Problems';
import { ImageCardsSection } from '../../components/Landing/ImageCardsSection';
import { NumberedCard } from '../../components/Landing/NumberedCard';
import { ImageContentSection } from '../../components/Landing/ImageContentSection';
import { Chapters } from '../../components/Landing/Chapters';
import { CtaSection } from '../../components/Landing/CtaSection';
import { FaqSection } from '../../components/Landing/FaqSection';
import { FeaturesList } from '../../components/FeaturesList';
import { ButtonNew } from '../../components/ButtonNew';
import { uiConfig } from '../../app-ui-config';
import storyStepsSrc from '../../assets/images/start/story-steps.webp';
import yourLifeSrc from '../../assets/images/start/your-life.webp';
import yourLifeMobileSrc from '../../assets/images/start/your-life-mobile.webp';
import styles from './StartPage.css';

const STORY_STEPS = [
    {
        title: 'Choose your chapter',
        description: 'Start with any of seven story categories. Skip what does not feel right and focus on what feels meaningful today.'
    },
    {
        title: 'Answer in your own way',
        description: 'Speak or type. Boundly selects the next question based on what you share, so the conversation stays personal.'
    },
    {
        title: 'Watch your story take shape',
        description: 'Do not worry about structure or wording. Boundly shapes your answers into clear, edited chapters as you go.'
    }
];

function StartPage() {
    return (
        <div className={styles.root}>
            <Hero />
            <Problems />
            <ImageCardsSection
                title='Your story, one question at a time'
                imageSrc={storyStepsSrc}
                withTestimonials
            >
                {STORY_STEPS.map((step, index) => (
                    <NumberedCard
                        key={step.title}
                        number={index + 1}
                        title={step.title}
                        description={step.description}
                    />
                ))}
            </ImageCardsSection>
            <ImageContentSection
                imageSrc={yourLifeSrc}
                imageMobileSrc={yourLifeMobileSrc}
                imageAlt='Two women looking at a Digital Family Legacy Book on a tablet'
            >
                <h2 className={styles.bookTitle}>Your life, shaped into a Digital Family Legacy Book</h2>
                <p className={styles.bookSubtitle}>Boundly brings your memories together in a fully digital format you can revisit from anywhere. There is no printed copy and no shipping to wait for.</p>
                <FeaturesList
                    type='book'
                    className={styles.bookList}
                />
                <ButtonNew
                    type='pill'
                    label='Get started'
                    link={{
                        to: uiConfig.prelanderLink,
                        target: '_blank'
                    }}
                />
            </ImageContentSection>
            <Chapters />
            <CtaSection />
            <FaqSection />
        </div>
    );
}

export {
    StartPage
};
